// 9fbef606107a605d69c0edbcd8029e5d
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import DynamicInjectOfferDetails from '@tcp/core/src/components/common/organisms/OfferDetails/container/DynamicInjectOfferDetails.js';
import OfferDetails from '@tcp/core/src/components/common/organisms/OfferDetails';
import PromoMessage from '@tcp/core/src/components/common/organisms/Promotions/atoms/PromoMessage';
import RecommendationPromoMessage from '@tcp/core/src/components/common/organisms/Promotions/atoms/RecommendationPromoMessage';
import {
  PromotionsContainer,
  Promotion,
  RecommendationsPromotionsContainer,
} from '../styles/Promotions.style';
import { createPromoArray } from '../../../../../../../utils';
import SafeComponent from '../../../../../../common/hoc/withErrorBoundary/errorBoundary';

/**
 Promotion component rendered on Bundle Pages.
 */
function Promotions({
  className,
  isBuyMorePromoEnabled,
  serverTime,
  promotionsData,
  TCPPromotionPrice,
  TCPPromotionID,
  isUpdatedPromotionsDisplayEnabled,
  brand,
  isFormRecommendationTile = false,
}) {
  const [isOfferDetailsModalActive, setOfferDetailsModalActive] = useState(false);
  const [clickedMessage, setClickedMessage] = useState(null);

  const promo = createPromoArray({
    promotionsData,
    serverTime,
    TCPPromotionPrice,
    TCPPromotionID,
    isUpdatedPromotionsDisplayEnabled,
  });

  const getUnderLineClass = (isUnderLine) => (isUnderLine === 'true' ? 'underLine' : null);

  const openOfferDetails = async (message) => {
    setClickedMessage(message);
    await DynamicInjectOfferDetails();
    setOfferDetailsModalActive(true);
  };

  function promotionPlacement(message, index) {
    return (
      index <= 1 &&
      message?.promotionMessage && (
        <Promotion>
          <BodyCopy
            onClick={() => openOfferDetails(message)}
            anchorVariation="primary"
            fontSizeVariation="medium"
            fontFamily="secondary"
            fontSize="fs12"
            className={`promo_message_anchor ${getUnderLineClass(message?.clickable)}`}
          >
            <PromoMessage message={message} isPlp />
          </BodyCopy>
        </Promotion>
      )
    );
  }

  function promotionRecommendationTile(message, index) {
    return (
      index <= 1 && message?.promotionMessage && <RecommendationPromoMessage message={message} />
    );
  }

  return (
    <>
      {isOfferDetailsModalActive && (
        <OfferDetails
          setOfferDetailsModalActive={setOfferDetailsModalActive}
          promo={clickedMessage}
          brand={brand}
        />
      )}
      {isFormRecommendationTile && promo?.length ? (
        <RecommendationsPromotionsContainer className={className}>
          {promo.map((message, index) => {
            return promotionRecommendationTile(message, index);
          })}
        </RecommendationsPromotionsContainer>
      ) : null}
      {isBuyMorePromoEnabled && promo?.length ? (
        <PromotionsContainer className={className}>
          {promo.map((message, index) => {
            return promotionPlacement(message, index);
          })}
        </PromotionsContainer>
      ) : null}
    </>
  );
}

Promotions.propTypes = {
  className: PropTypes.string,
  isBuyMorePromoEnabled: PropTypes.bool,
  serverTime: PropTypes.number,
  promotionsData: PropTypes.shape({}),
  brand: PropTypes.string,
};

Promotions.defaultProps = {
  className: '',
  isBuyMorePromoEnabled: false,
  serverTime: null,
  promotionsData: {},
  brand: '',
};
export default SafeComponent(Promotions);
